import { useEffect, useState } from "react";

export default function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("sy_cookie_consent")) setShow(true);
  }, []);

  const choose = (val) => {
    localStorage.setItem("sy_cookie_consent", val);
    setShow(false);
  };

  if (!show) return null;
  return (
    <div
      className="fixed bottom-[calc(4.5rem+env(safe-area-inset-bottom))] md:bottom-4 left-4 right-4 md:right-auto md:max-w-md z-50 p-4 rounded-2xl bg-[#0b1322] border border-[#1e9bff]/40 sy-glow-card"
      data-testid="cookie-banner"
    >
      <p className="text-xs text-[#c8d9ea] mb-3">
        We use essential cookies to make this site work and optional analytics to improve it. You can accept or decline — see our Privacy Policy for details.
      </p>
      <div className="flex gap-3">
        <button onClick={() => choose("accepted")} data-testid="cookie-accept-btn"
          className="flex-1 py-2.5 rounded-xl bg-[#1e9bff] text-black text-xs font-bold uppercase tracking-wider hover:bg-[#60baff] transition-colors">
          Accept
        </button>
        <button onClick={() => choose("declined")} data-testid="cookie-decline-btn"
          className="flex-1 py-2.5 rounded-xl border border-white/20 text-[#93b4d4] text-xs font-mono-lbl uppercase tracking-wider hover:bg-white/5 transition-colors">
          Decline
        </button>
      </div>
    </div>
  );
}
